/* eslint @typescript-eslint/explicit-function-return-type: off */

export const indexPath = (projectId) => `/projects/${projectId}/jobs`;
export const createPath = indexPath;
export const detailsPath = (projectId, jobId) =>
  `/projects/${projectId}/jobs/${jobId}`;
